import React from 'react';
import Iconos from './iconos';
import styled from '@emotion/styled';
import { GatsbyImage } from "gatsby-plugin-image";
import { Link } from 'gatsby';
import urlSlug from 'url-slug';

const Boton = styled(Link) `
    margin-top: 2rem;
    padding: 1rem;
    background-color: #75ab00;
    width: 100%;
    color: #fff;
    display: block;
    text-decoration: none;
    text-align: center;
    font-weight: 700;
    text-transform: uppercase;

    @media( max-width: 768px) {
        font-size: 1rem;
        margin-top: 0.2rem;
    }
`;

const Card = styled.div`
    border: 1px solid #E1E1E1;
    padding: 0.7rem;
    margin-bottom: 2rem;

    .imagenPropiedad {
        max-width: 350px;
        max-height: 300px;

    @media( max-width: 768px) {
        max-width: 220px;
        max-height: 150px;
    }
    }
`;

const Contenido = styled.div`
    
    display: grid;
    justify-content: center;
    

    h3 {
        font-family: 'Lato', sans-serif;
        font-size: 2.4 rem;
        text-align: center;
        margin-top: 1rem;
    }
    .precio {
        font-size: 2rem;
        color: #75AB00;
        text-align: center;

        @media( max-width: 768px) {
        font-size: 2rem;
        
    }

    p {
        @media( max-width: 425px) {
        margin: 0;
    }

    @media( max-width: 480px) {
        max-width: 100%;
    }

    @media( max-width: 768px) {
        height: 100%;
    }

`;

const PropiedadPreview = ({ propiedad }) => {

    const { nombre, imagen, wc, estacionamiento, habitaciones, precio } = propiedad;

    return (
        <Card>
            <Contenido>
            {imagen ? <GatsbyImage className="imagenPropiedad" image={imagen.sharp.gatsbyImageData} alt="imagen propiedad"/> : <p>No imagen</p>}
                <h3>{nombre}</h3>
                <p className="precio">$ {precio}</p>
                <Iconos
                    wc={wc}
                    estacionamiento={estacionamiento}
                    habitaciones={habitaciones}
                />
                <Boton
                    to={urlSlug(nombre)}
                >
                    Visitar Propiedad
                </Boton>
            </Contenido>
        </Card>
    );
}

export default PropiedadPreview;